import { BaseContainerModel } from "../base-container.model";
import {
  bl_wms_warehouse_layout_hdr_RowClass,
  bl_wms_warehouse_layout_hdr_RowInterface,
} from "../../dbschema/index";

export class WarehouseLayoutContainerModel extends BaseContainerModel {
  bl_wms_warehouse_layout_hdr: bl_wms_warehouse_layout_hdr_RowInterface =
    new bl_wms_warehouse_layout_hdr_RowClass();
}
